import axios from 'axios';
import { store } from '../store';
import { logout } from '../store/slices/auth.slice';
import { showSnackbar } from '../store/slices/common.slice';

// Define your base configuration
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// ✅ Add request interceptor for auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const { token } = state.auth;
    // const token = localStorage.getItem("access_token");
    if (token) {
      return {
        ...config,
        headers: {
          ...config.headers,
          Authorization: `Bearer ${token}`,
          'x-api-key': process.env.REACT_APP_API_KEY,
        },
      };
    }
    return {
      ...config,
      headers: {
        ...config.headers,
        'x-api-key': `efer6f4r8e1ce98rgf1c98e4rfrfrerf`,
      },
    };
  },
  (error: any) => Promise.reject(error)
);

// ✅ Add response interceptor for global error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error: any) => {
    console.error('==========Server error', error);
    const errorCode: string = error?.code || '';
    if (errorCode === 'ERR_NETWORK') {
      return Promise.reject(error);
    }
    const statusCode = error.response?.status;
    if (statusCode === 401) {
      store.dispatch(logout());
      store.dispatch(
        showSnackbar({
          message: `Session expired. Page will be reload after 5 seconds`,
          severity: 'error',
        })
      );
      // store.dispatch(showLoader());
      // setTimeout(() => {
      //   // window.location.href = '/';
      // }, 5000);
    }
    return Promise.reject(error.response);
  }
);

export default axiosInstance;
